import React from 'react';
import './portfolio.css';
import IMG1 from '../../assets/portfolio1.jpg';
import IMG2 from '../../assets/portfolio3.jpg';
import IMG3 from '../../assets/portfolio2.jpg';
import IMG4 from '../../assets/portfolio4.jpg';
import IMG5 from '../../assets/portfolio5.jpg';
import IMG6 from '../../assets/portfolio6.jpg';

const data = [
    {
        id: 1,
        image: IMG1,
        title: 'HIMMI POLSUB DIFEST 2022 Web App (Codeigniter 4)',
        year: 2021,
        github: 'https://github.com/renaldin',
        demo: 'https://digitalfestival.himmi-polsub.com/'
    },
    {
        id: 2,
        image: IMG2,
        title: 'Cloud Management Web Application (React Js)',
        year: 2022,
        github: 'https://github.com/renaldin/cloud-app-react',
        demo: 'https://dribbble.com/shots/18935728-Cloud-Management-Web-Application-using-React-Js'
    },
    {
        id: 3,
        image: IMG3,
        title: 'HIMMI POLSUB Web Application (Codeigniter 4)',
        year: 2022 + ' (Tim Ristek HIMMI)',
        github: 'https://github.com/renaldin',
        demo: 'https://www.himmi-polsub.com/'
    },
    {
        id: 4,
        image: IMG4,
        title: 'Annual Revenue List Web Application (React Js)',
        year: 2022,
        github: 'https://github.com/renaldin/revenue-list-react',
        demo: 'https://dribbble.com/shots/18935577-Annual-Revenue-List-Web-App-Using-React-Js'
    },
    {
        id: 5,
        image: IMG5,
        title: 'Portfolio Web Application (HTML5, Bootstrap)',
        year: 2021,
        github: 'https://github.com/renaldin/portfolio-web-app',
        demo: 'https://dribbble.com/shots/18935672-Portfolio-Web-Application-using-HTML-and-Bootstrap'
    },
    {
        id: 6,
        image: IMG6,
        title: 'Todo List Web Application (React Js)',
        year: 2022,
        github: 'https://github.com/renaldin/my-todo-list',
        demo: 'https://dribbble.com/shots/18935635-Todo-List-Web-Application-Using-React-Js'
    }
];

const Portfolio = () => {
    return (
        <section id='portfolio'>
            <h5>My Recent Work</h5>
            <h2>Portfolio</h2>

            <div className="container portfolio__container">
                {
                    data.map(({ id, image, title, year, github, demo }) => {
                        return (
                            <article key={id} className='portfolio__item'>
                                <div className="portfolio__item-image">
                                    <img src={image} alt={title} />
                                </div>
                                <h3>{title}</h3>
                                <span>Made in {year}</span>
                                <div className="portfolio__item-cta">
                                    <a href={github} className='btn' target='_blank'>Github</a>
                                    <a href={demo} className='btn btn-primary' target='_blank'>Live Demo</a>
                                </div>
                            </article>
                        )
                    })
                }
            </div>
        </section>
    )
}

export default Portfolio